import { Outlet, useLocation, useNavigate } from "react-router"
import { useTranslation } from "react-i18next"
import { BottomNavbar, DashboardIcon, UserIcon, VoteIcon } from "@cividao/components"
import { useUserInfoStore } from "../../../state/stores/userInfoStore"
import { Topbar } from "./Topbar"
import styles from "./index.module.css"

export function LayoutTemplate() {
  const { pathname: currentRoute } = useLocation()
  const { t } = useTranslation("common")
  const navigate = useNavigate()
  const existingRoles = useUserInfoStore((state) => state.userInfo?.participationRoles)

  const handleRouteChange = (url: string) => {
    navigate(url, { viewTransition: true })
  }

  const bottomItems = [
    {
      label: t("dashboard"),
      url: "/dashboard",
      icon: DashboardIcon,
    },
    {
      label: t("myVotings"),
      url: "/my-votings",
      icon: VoteIcon,
    },
    {
      label: t("profile"),
      url: "/profile",
      icon: UserIcon,
    },
  ]

  const isFirstTimeSetup = currentRoute === "/participation-preference" && !existingRoles
  const hideNav = isFirstTimeSetup

  return (
    <div className={styles.layoutContainer}>
      <header className={styles.layoutHeader}>
        <Topbar />
      </header>
      <main className={styles.layoutMain}>
        <Outlet />
      </main>
      {!hideNav && (
        <footer className={styles.layoutFooter}>
          <div className={styles.bottomNavBar}>
            <BottomNavbar
              menuItems={[]}
              bottomItems={bottomItems}
              currentRoute={currentRoute}
              showLabels
              onRouteChange={handleRouteChange}
            />
          </div>
        </footer>
      )}
    </div>
  )
}
